import type { Settings as LayoutSettings } from '@ant-design/pro-components';
import { SettingDrawer } from '@ant-design/pro-components';
import { LoginResult } from '@/services/typing';
import { RunTimeLayoutConfig } from '@@/plugin-layout/types';
import { history } from '@umijs/max';
import { getUserData } from '@/utils/user';
import type { RequestConfig } from '@umijs/max';
import {
  AvatarDropdown,
  AvatarName,
  Footer,
} from '@/components';
import defaultSettings from '../config/defaultSettings';
import '@ant-design/v5-patch-for-react-19';

import { requestConfig } from '@/requestConfig';

const loginPath = '/user/login';

/**
 * @see  https://umijs.org/zh-CN/plugins/plugin-initial-state
 * */
export async function getInitialState(): Promise<{
  settings?: Partial<LayoutSettings>;
  currentUser?: LoginResult;
  runtime?: any;
  fetchUserInfo?: () => Promise<LoginResult | undefined>;
}> {
  const currentUser = getUserData();

  return {
    settings: defaultSettings as Partial<LayoutSettings>,
    currentUser: currentUser || undefined,
  };
}

// ProLayout 支持的api https://procomponents.ant.design/components/layout
export const layout: RunTimeLayoutConfig = ({ initialState, setInitialState }) => {
  return {
    actionsRender: () => [],
    avatarProps: {
      title: <AvatarName />,
      render: (_, avatarChildren) => {
        return <AvatarDropdown>{avatarChildren}</AvatarDropdown>;
      },
    },
    waterMarkProps: {},
    footerRender: () => <Footer />,

    // 禁用菜单 tooltip，避免 findDOMNode 警告
    menu: {
      collapsedShowTitle: false,
    },

    onPageChange: () => {
      const { location } = history;
      if (!initialState?.currentUser?.userID && location.pathname !== loginPath) {
        history.push(loginPath);
        return;
      }
      
      // 注释掉强制跳转逻辑，让用户可以在设置完成后正常访问其他页面
      // 设置完成检查在 Profile 页面内部处理
      // if (initialState?.currentUser?.userID && 
      //     initialState?.currentUser?.role === 2 && // 普通用户角色
      //     location.pathname !== '/user/profile' && 
      //     location.pathname !== '/user/password' &&
      //     location.pathname !== loginPath) {
      //   history.push('/user/profile');
      // }
    },
    bgLayoutImgList: [
      {
        src: 'https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/D2LWSqNny4sAAAAAAAAAAAAAFl94AQBr',
        left: 85,
        bottom: 100,
        height: '303px',
      },
      {
        src: 'https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/C2TWRpJpiC0AAAAAAAAAAAAAFl94AQBr',
        bottom: -68,
        right: -45,
        height: '303px',
      },
      {
        src: 'https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/F6vSTbj8KpYAAAAAAAAAAAAAFl94AQBr',
        bottom: 0,
        left: 0,
        width: '331px',
      },
    ],
    menuHeaderRender: undefined,
    // 自定义 403 页面
    // unAccessible: <div>unAccessible</div>,
    // 增加一个 loading 的状态
    childrenRender: (children) => {
      // if (initialState?.loading) return <PageLoading />;
      return (
        <>
          {children}
          {process.env.NODE_ENV === 'development' && (
            <SettingDrawer
              disableUrlParams
              enableDarkTheme
              settings={initialState?.settings}
              onSettingChange={(settings) => {
                setInitialState((preInitialState) => ({
                  ...preInitialState,
                  settings,
                }));
              }}
            />
          )}
        </>
      );
    },
    ...initialState?.settings,
  };
};

/**
 * @name request 配置，可以配置错误处理
 * 它基于 axios 和 ahooks 的 useRequest 提供了一套统一的网络请求和错误处理方案。
 * @doc https://umijs.org/docs/max/request#配置
 */
export const request: RequestConfig = {
  ...requestConfig,
};